class Header {
    constructor(el) {
        this.scope = el;
        this.logo = el.querySelector("[data-header-logo]");
        this.buttons = el.querySelectorAll("[data-header-buttons] .button");
        this.burger = el.querySelector("[data-burger]");
        this.primaryLinks = el.querySelectorAll("[data-primary-link]");
        this.backLinks = el.querySelectorAll("[data-back]");
        this.closeLinks = el.querySelectorAll("[data-close]");
        this.openCallLinks = document.querySelectorAll("[data-toggle-call]");
        this.navigations = el.querySelectorAll("[data-navigation]");
        this.navOpen = false;
        this.callOpen = false;
        this.resizeId = null;
        this.isDesktop = this.checkIfDesktop();
        this.internal = false;
        this.bindTab = e => {
            if (!e.target.closest("[data-header]")) {
                this.toggleNav();
                document.removeEventListener("keyup", this.bindTab);
            }
        };
        this.bindEvents();
    }
    bindEvents() {
        this.scope.querySelectorAll(".header__bottom__nav__links__item--active").length > 0 && this.scope.classList.add("header--active");
        window.addEventListener("resize", () => {
            this.waitForResize();
        });
        if (this.primaryLinks.length === 1 && this.scope.querySelectorAll(".header__bottom__nav__links__item--hide-label").length > 0 && this.buttons.length > 0) {
            this.logo.addEventListener("keydown", event => {
                if (event.key === 'Tab' && !event.shiftKey && viewport() > 1) {
                    event.preventDefault();
                    this.buttons[0].focus();
                }
            });
            this.buttons[0].addEventListener("keydown", event => {
                if (event.key === 'Tab' && event.shiftKey && viewport() > 1) {
                    event.preventDefault();
                    this.logo.focus();
                }
            });
            this.buttons[this.buttons.length - 1].addEventListener("keydown", event => {
                if (event.key === 'Tab' && !event.shiftKey && viewport() > 1 && this.scope.querySelectorAll(".navigation__items__item__link").length > 0) {
                    event.preventDefault();
                    this.scope.querySelectorAll(".navigation__items__item__link")[1].focus();
                }
            });
            this.buttons[this.buttons.length - 1].addEventListener("keyup", event => {
                if (event.key === 'Tab' && event.shiftKey && viewport() > 1 && this.scope.querySelectorAll(".navigation__items__item__link").length > 0 && !this.internal) {
                    event.preventDefault();
                    this.scope.querySelectorAll(".navigation__items__item__link")[this.scope.querySelectorAll(".navigation__items__item__link").length - 1].focus();
                } else {
                    this.internal = false;
                }
            });
            this.scope.querySelectorAll(".navigation__items__item__link")[1].addEventListener("keydown", event => {
                if (event.key === 'Tab' && event.shiftKey && viewport() > 1 && this.primaryLinks.length === 1 && this.scope.querySelectorAll(".navigation__items__item__link").length > 0) {
                    this.internal = true;
                    event.preventDefault();
                    this.buttons[this.buttons.length - 1].focus();
                }
            });
            this.scope.querySelectorAll(".navigation__items__item__link")[this.scope.querySelectorAll(".navigation__items__item__link").length - 1].addEventListener("keydown", event => {
                if (event.key === 'Tab' && !event.shiftKey && viewport() > 1 && this.primaryLinks.length === 1 && this.scope.querySelectorAll(".navigation__items__item__link").length > 0) {
                    this.buttons[this.buttons.length - 1].focus();
                }
            });
        }
        this.burger.addEventListener("click", () => this.toggleNav());
        this.primaryLinks.forEach(link => {
            link.addEventListener("click", () => {
                link.parentNode.setAttribute("data-open", "");
                if (this.scope.classList.contains("header--has-tag-line")) {
                    if (viewport() < 1 && window.scrollY < 32) {
                        this.scope.style.setProperty('--header-offset', `${32 - window.scrollY}px`);
                    } else {
                        this.scope.style.removeProperty('--header-offset');
                    }
                }
            });
        });
        this.backLinks.forEach(link => {
            link.addEventListener("click", () => {
                if (link.closest("[data-details]")) {
                    link.closest("[data-details]").open = false;
                } else if (link.closest("[data-open]")) {
                    link.closest("[data-open]").removeAttribute("data-open");
                } else if (link.closest(".header__bottom__nav__links__item--active")) {
                    link.closest(".header__bottom__nav__links__item--active").classList.remove("header__bottom__nav__links__item--active");
                }
            });
        });
        this.closeLinks.forEach(close => {
            close.addEventListener('click', () => {
                if (viewport() > 2) {
                    document.querySelector("html").classList.remove("overlay");
                    document.querySelector("html").classList.remove("nav-open");
                }
                this.scope.querySelectorAll('[data-details]').forEach(details => {
                    details.parentElement.classList.remove("navigation__items__item--open");
                });
                this.scope.querySelectorAll('.navigation').forEach(navigation => {
                    navigation.classList.remove('navigation--open');
                });
            });
        });
        this.openCallLinks.forEach(link => {
            link.addEventListener("click", () => {
                viewport() === 0 && this.toggleCall();
            });
        });
        this.navigations.forEach(nav => {
            //single link height
            if(nav.querySelectorAll("li").length > 1){
                let navHeight = nav.querySelectorAll("li")[1].offsetHeight;
                nav.addEventListener("open", () => {
                    //if more than 1 row of links
                    if (nav.offsetHeight !== navHeight) {
                        this.scope.style.setProperty('--nav-offset-height', `${nav.offsetHeight}px`);
                    }
                });
            }
        });
    }
    waitForResize() {
        clearTimeout(this.resizeId);
        this.resizeId = setTimeout(() => {
            if (this.checkIfDesktop() !== this.isDesktop) {
                this.navOpen && this.toggleNav();
                if (viewport() > 2) {
                    document.querySelector("html").classList.remove("overlay");
                    document.querySelector("html").classList.remove("nav-open");
                }
                this.isDesktop = this.checkIfDesktop();
            }
        }, 300);
    }
    checkIfDesktop() {
        return viewport() > 1;
    }
    toggleNav() {
        this.navOpen = !this.navOpen;
        this.scope.classList.toggle("header--open", this.navOpen);
        document.querySelector("html").classList.toggle("overflow-hidden", this.navOpen);
        this.scope.querySelectorAll("[data-open]").length > 0 && this.scope.querySelector("[data-open]").removeAttribute("data-open");
        this.scope.querySelectorAll(".navigation__items__item--open").length > 0 && this.scope.querySelector(".navigation__items__item--open").classList.remove("navigation__items__item--open");
        if (this.navOpen) {
            document.addEventListener("keyup", this.bindTab);
            this.displayMessage(this.burger, 'Close Menu');
            if (viewport() < 2 && this.primaryLinks.length === 1 && this.primaryLinks[0].parentElement.classList.contains("header__bottom__nav__links__item--hide-label")) {
                this.primaryLinks[0].parentElement.setAttribute("data-open", "");
            }
        } else {
            this.displayMessage(this.burger, 'Open Menu');
            this.scope.querySelectorAll("[data-navigation]").forEach(nav => {
                nav.navigation.closeMegaNav();
            });
        }
    }
    displayMessage(el, message) {
        if (el != null) {
            el.setAttribute('aria-label', message);
            el.setAttribute('title', message);
        }
    }
    toggleCall() {
        this.callOpen = !this.callOpen;
        this.scope.classList.toggle("header--open", this.callOpen);
        this.scope.classList.toggle("header--call", this.callOpen);
        document.querySelector("html").classList.toggle("overflow-hidden--mobile", this.callOpen);
        if (this.callOpen) {
            this.scope.querySelector("[data-call-overlay] [data-toggle-call]").focus();
        } else {
            this.scope.querySelector("[data-toggle-call]").focus();
            this.navOpen = false;
        }
    }
}
ControlBinders.register(`[data-header]`, el => new Header(el));
//# sourceMappingURL=dcc.header.js.map
